export const DEFAULT_FILTERS = "defaultFilters"
